import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonIcon, IonPopover } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { informationCircleOutline } from 'ionicons/icons';

addIcons({ informationCircleOutline });

@Component({
  selector: 'crowdctrl-info-popover',
  standalone: true,
  imports: [CommonModule, IonIcon, IonPopover],
  templateUrl: './info-popover.component.html',
  styleUrl: './info-popover.component.css',
})
export class InfoPopoverComponent {
  @ViewChild('popover') private popover!: IonPopover;

  @Input() ariaLabel = 'Information';
  @Input() icon = 'information-circle-outline';
  @Input() message: string | null = null;
  @Input() maxWidth = '16rem';

  open(event: Event): void {
    event.preventDefault?.();
    this.popover.event = event;
    void this.popover.present();
  }

  onTriggerKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.open(event);
  }
}
